module.exports = __webpack_public_path__ + "media/1x1/na-74257fb2.svg";